import { Deserializable } from '../../protocols/deserializable';

export class ChangePasswordRequest implements Deserializable {
  public oldPassword: string = '';
  public newPassword: string = '';
  onDeserialize = () => {};
}
